import React from 'react';

import Container from "./Container";
import Category from "./Category";
import AssetGroup from "./AssetGroup";

function Component({ component, className, showDecommissioned }) {
  const [ selectedAsset, setSelectedAsset ] = React.useState(null);
  const [ dependenciesOfSelected, setDependenciesOfSelected ] = React.useState(null);
  const [ dependentsOfSelected, setDependentsOfSelected ] = React.useState(null);
  const onSelectAsset = (asset, dependencies, dependents) => {
    if (asset == selectedAsset) {
      setSelectedAsset(null);
      setDependenciesOfSelected(null);
      setDependentsOfSelected(null);
    } else {
      setSelectedAsset(asset);
      setDependenciesOfSelected(dependencies);
      setDependentsOfSelected(dependents);
    }
  };

  return (
    <>
      <Container
        className={className}
        href={component.link}
        icon={component.icon}
        title={component.name}
        onSelectAsset={onSelectAsset}
      >
        {
          (component.assets || []).length > 0 ?
            // These assets have no group. Let's create a fake one to hold them.
            <AssetGroup
              group={{
                assets: component.assets.filter(a => showDecommissioned || !a.decommissioned),
                name: 'Assets',
                icon: 'fa-cubes',
                dependencies: [],
                dependents: [],
              }}
              showDecommissioned={showDecommissioned}
              selectedAsset={selectedAsset}
              onSelectAsset={onSelectAsset}
            />
            :
            null
        }
        {
          (component.assetGroups || []).map(
            (agc) => (
              <Category
                key={agc.id}
                category={agc}
                showDecommissioned={showDecommissioned}
                selectedAsset={selectedAsset}
                onSelectAsset={onSelectAsset}
                dependenciesOfSelected={dependenciesOfSelected}
                dependentsOfSelected={dependentsOfSelected}
              />
            )
          )
        }
      </Container>
      
      <div className="d-flex w-100 align-items-center gap-x-8 mt-2">
        { 
          dependenciesOfSelected && dependenciesOfSelected.length > 0 ? 
            <div className="d-flex align-items-center py-2">
              <div className="dependency-key-line mr-2"></div>
              <span className='dependency'>{selectedAsset.name} dependency</span>
            </div> : null
        }
        { 
          dependentsOfSelected && dependentsOfSelected.length > 0 ?
            <div className="dependent-of-selected px-3 py-2">
              <span>Dependent on {selectedAsset.name}</span>
            </div> : null
        }
        {
          selectedAsset && selectedAsset.link ?
            <a className="btn btn-primary ml-auto" href={selectedAsset.link}>
              View {selectedAsset.name} {`>>`}
            </a> : null
        }
      </div>
    </>
  )
}

export default Component
